import { HeadquarterModel } from '@/models/config'
import { HeadquarterService } from '@/services/config'
import { ref, Ref, computed } from '@vue/composition-api'

export default function useHeadquarter () {
  const loadingHeadquartes = ref(false)
  const headquarters: Ref<HeadquarterModel[]> = ref([])

  const getHeadquatersActivated = async () => {
    loadingHeadquartes.value = true
    headquarters.value = await HeadquarterService.getAllActivate()
    loadingHeadquartes.value = false
  }

  const headquartersSelectOptions = computed(() => {
    return headquarters.value.map(type => {
      return {
        value: Number(type.id),
        text: type.name
      }
    })
  })

  return { headquarters, headquartersSelectOptions, getHeadquatersActivated, loadingHeadquartes }
}
